import { DataBean } from "../DataBean";

export class DocumentTypeC extends DataBean {

    public async getDocumentTypeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getDocumentTypeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }  

}